const SHOW_DELAY_MS = 0;
const MIN_VISIBLE_MS = 400;
const HIDE_DELAY_MS = 150;

let pendingCount = 0;
let visible = false;
let displayContext = null;
let showTimer = null;
let hideTimer = null;
let shownAt = null;
const listeners = new Set();

function getState() {
  return {
    pendingCount,
    isLoading: visible,
    context: displayContext,
  };
}

function notify() {
  const state = getState();
  listeners.forEach((listener) => listener(state));
}

function clearHideTimer() {
  if (hideTimer) {
    clearTimeout(hideTimer);
    hideTimer = null;
  }
}

function scheduleHide() {
  clearHideTimer();

  const elapsed = shownAt ? Date.now() - shownAt : 0;
  const delay = Math.max(HIDE_DELAY_MS, MIN_VISIBLE_MS - elapsed);

  hideTimer = setTimeout(() => {
    hideTimer = null;
    visible = false;
    displayContext = null;
    shownAt = null;
    notify();
  }, delay);
}

function showLoaderNow() {
  if (showTimer) {
    clearTimeout(showTimer);
    showTimer = null;
  }
  if (pendingCount > 0) {
    visible = true;
    shownAt = Date.now();
    notify();
  }
}

export function subscribeApiLoading(listener) {
  listeners.add(listener);
  listener(getState());
  return () => listeners.delete(listener);
}

export function startApiLoading(context) {
  pendingCount += 1;

  if (context) {
    displayContext = context;
  }

  clearHideTimer();

  if (!visible) {
    if (SHOW_DELAY_MS <= 0) {
      showLoaderNow();
    } else if (!showTimer) {
      showTimer = setTimeout(() => {
        showTimer = null;
        showLoaderNow();
      }, SHOW_DELAY_MS);
    }
  } else {
    notify();
  }
}

export function endApiLoading() {
  pendingCount = Math.max(0, pendingCount - 1);

  if (pendingCount > 0) {
    if (visible) {
      notify();
    }
    return;
  }

  if (showTimer) {
    clearTimeout(showTimer);
    showTimer = null;
    displayContext = null;
    notify();
    return;
  }

  if (visible) {
    scheduleHide();
    return;
  }

  displayContext = null;
  notify();
}
